import { get, post } from "utilities/network";

export type WaitlistOption = {
  value: string;
  label: string;
};

export type WaitlistOptions = {
  tradeFrequency: WaitlistOption[];
  primaryCryptoActivity: WaitlistOption[];
  monthlyVolumeRange: WaitlistOption[];
  frustrations: WaitlistOption[];
};

export type WaitlistPayload = {
  fullName: string;
  email: string;
  whatsappNumber: string;
  referralTag: string;
  tradeFrequency: string;
  primaryCryptoActivity: string;
  monthlyVolumeRange: string;
  frustrations: string[];
  removeForever: string;
};

export type WaitlistJoinResult = {
  alreadyOnWaitlist: boolean;
  // Public position on the list, allocated from a dedicated sequence on the
  // server. Returned for new joins and for people already on the waitlist.
  waitlistNumber: number;
};

export type WaitlistJoinResponse = {
  status: string;
  data: WaitlistJoinResult | null;
  message: string | null;
  error: Record<string, string> | null;
};

export const waitlistOptionsQueryKey = ["public", "waitlist", "options"];

export const httpWaitlistOptions = (): Promise<WaitlistOptions> => {
  return get("waitlist/options");
};

export const httpJoinWaitlist = (
  payload: WaitlistPayload,
): Promise<WaitlistJoinResponse> => {
  return post("waitlist", payload);
};
